import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dyalog': {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M0 32h171.2c74.5 0 137.7 24 182.5 69.6 40.2 40.9 62.3 95.6 62.3 154.3 0 111.4-84.1 224.1-244.8 224.1h-171.2v-64h171.2c122.2 0 180.8-84 180.8-160.1 0-79.7-67.4-159.9-180.8-159.9h-107.2v55.2h-64v-119.2z'
      }
    ]
  }
})
